// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"0ff800c9","132":"8a092eaa","418":"12a3e7bb","777":"ebbbc10a"}[chunkId] + ".js";
};